export class ResellerFilter {
   razonSocial: string;
   rut: string;
   nombreContacto: string;
   activo: boolean;
}
